export default "__VITE_PUBLIC_ASSET__f59bf5c5__"